import { createRouter, createWebHistory } from "vue-router";

import Standings from "../pages/Standings.vue";
import UserProfile from "../pages/users/UserProfile.vue";
import UserEdit from "../pages/users/UserEdit.vue";
import NotFound from "../pages/NotFound.vue";
import store from "../store/index.js";

const SeasonsList = () => import("../pages/seasons/SeasonsList.vue");
const TeamsList = () => import("../pages/teams/TeamsList.vue");
const SchedulesList = () => import("../pages/schedules/SchedulesList.vue");
const UsersList = () => import("../pages/users/UsersList.vue");
const UserAuth = () => import("../pages/auth/UserAuth.vue");
const AdminList = () => import("../pages/admin/AdminList.vue");
const WeeklyResults = () => import("../pages/admin/WeeklyResults.vue");
const WeeklyGames = () => import("../pages/WeeklyGames.vue");
const DataExport = () => import("../pages/admin/DataExport.vue");

const routes = [
  {
    path: "/",
    name: "Home",
    component: Standings,
  },
  {
    path: "/weeklygames",
    component: WeeklyGames,
    meta: { requiresAuth: true, requiresClosedSeason: true }
  },
  {
    path: "/admin",
    component: AdminList,
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      {
        path: "/admin/seasons",
        component: SeasonsList,
        meta: { requiresAuth: true, requiresAdmin: true },
        //   {
        //     path: "/admin/seasons/:id",
        //     component: SeasonDetail,
        //     props: true,
        //     meta: { requiresAuth: true, requiresAdmin: true },
        //     children: [
        //       {
        //         path: "edit",
        //         component: SeasonEdit,
        //         meta: { requiresAuth: true, requiresAdmin: true },
        //       }, // /seasons/s1/edit
        //     ],
        // },
      },
      {
        path: "/admin/teams",
        component: TeamsList,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "/admin/schedules",
        component: SchedulesList,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "/admin/users",
        component: UsersList,
        meta: { requiresAuth: true, requiresAdmin: true },
        // children: [
        //   {
        //     path: "/admin/users/:id",
        //     component: UsersDetailAdmin,
        //     props: true,
        //     meta: { requiresAuth: true, requiresAdmin: true },
        //     children: [
        //       {
        //         path: "edit",
        //         component: UsersEditAdmin,
        //         meta: { requiresAuth: true, requiresAdmin: true },
        //       }, // /users/s1/edit
        //     ],
        // },
        // ]
      },
      {
        path: "/admin/weeks",
        component: WeeklyResults,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "/admin/dataexport",
        component: DataExport,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
    ],
  },
  {
    path: "/users/:id",
    component: UserProfile,
    props: true,
    children: [
      { path: "edit", component: UserEdit, meta: { requiresAuth: true } }, // /users/u1/edit
    ],
  },
  {
    path: "/users/:id/picks",
    component: () =>
      import("../pages/users/UserPicks.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  { path: "/auth", component: UserAuth, meta: { requiresUnauth: true } },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  { path: "/:notFound(.*)", component: NotFound },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(function (to, _, next) {
  console.group("router.beforeEach");
  if (to.meta.requiresAuth && !store.getters.isAuthenticated) {
    console.log("page requires Auth and we're not, next url was: ", to.path, "redirecting to /auth")
    next("/auth");
  } else if (to.meta.requiresAdmin && !store.getters.isAdmin) {
    console.log("page requires Admin and we're not, next url was: ", to.path, "redirecting to /")
    next("/");
  } else if (to.meta.requiresClosedSeason && store.getters["seasons/currentSeason"].tournamentPickingOpen) {
    console.log("page requires Season to be Closed and it isn't, next url was: ", to.path, "redirecting to /")
    next("/");
  } else if (to.meta.requiresOpenSeason && !store.getters["seasons/currentSeason"].tournamentPickingOpen) {
    console.log("page requires Season to be Open and it isn't, next url was: ", to.path, "redirecting to /")
    next("/");
  } else if (to.meta.requiresUnauth && store.getters.isAuthenticated) {
    console.log("page requires Unauth and we are, next url was: ", to.path, "redirecting to /")
    next("/");
  } else {
    console.log("page requirements passed, next url is", to.path)
    next();
  }
  console.groupEnd();
});

export default router;
